<!-- 结算卡 -->
<template>
    <div class="main" v-show="!loading">
        <div class="settle-top">
          <div class="title">{{ isAdd ? '添加银行卡' : '查看银行卡信息' }}</div>
          <div class="mask" v-if="!isAdd" @click="switchMask">
            <img v-if="!isMask" :src="maskImg" alt="">
            <img v-else :src="noMaskImg" alt="">
          </div>
        </div>
        <div
          class="ppw-form-container"
        >
          <elForm
            class="normal-form no-show-required"
            inline
            :key="key"
            ref="form"
            :model="form"
            :disabled="!isAdd"
            :rules="rules"
            @submit.native.prevent
          >
            <!-- 开户银行 -->
            <elFormItem :label="$t('app.label.bankAccount')" :readOnly="!isAdd" prop="bankName">
              <elInput
                v-model="form.bankName"
                placeholder="请输入银行名称(如:工商银行)"
              />
            </elFormItem>

            <!-- 开户名称 -->
            <elFormItem label="开户行名称" :readOnly="!isAdd" prop="bankAccountName">
              <elInput
                v-model="form.bankAccountName"
                placeholder="请输入开户行名称(如工商银行杭州奥体支行)"
              />
            </elFormItem>

            <!-- 银行账号 -->
            <elFormItem :label="$t('app.label.bankCard')" :readOnly="!isAdd" prop="bankCard">
              <elInput
                v-model="form.bankCard"
                @input="form.bankCard = form.bankCard.replace(/\D/g, '')"
                :placeholder="$t('app.sentence.bankCard')"
              />
            </elFormItem>

            <!-- 开户人姓名 -->
            <elFormItem label="开户人姓名" :readOnly="!isAdd" prop="accountName">
              <elInput
                v-model="form.accountName"
                placeholder="请输入开户人姓名"
              />
            </elFormItem>

            <!-- 身份证号 -->
            <elFormItem label="身份证号码" :readOnly="!isAdd" prop="idCard">
              <elInput
                v-model="form.idCard"
                placeholder="请输入身份证号码"
              />
            </elFormItem>

            <!-- 绑定手机号 -->
            <elFormItem label="手机号" :readOnly="!isAdd" prop="bankPhone">
              <elInput
                v-model="form.bankPhone"
                placeholder="请输入该银行卡预留手机号"
              >
              </elInput>
            </elFormItem>
          </elForm>
        </div>
        <div class="signature" v-if="isAdd">
          <div class="signature-item">
            <div class="img-box" @click="switchSign('signPrivacy')">
              <img v-if="!form.signPrivacy" :src="offIcon" alt="">
              <img v-else :src="onIcon" alt="">
            </div>
            <div class="content">本人已阅读、知晓并同意 <span class="link-text" @click="viewAgreement('sensitive')">《敏感个人信息处理事宜授权书》</span> 的条款，知晓并同意提供上述信息并按照<span class="link-text" @click="viewAgreement('privacy')">《隐私政策》</span>进行传输。</div>
          </div>
          <div class="signature-item" v-if="showSignPartner">
            <div :title="form.signPartner" class="img-box" @click="switchSign('signPartner')">
              <img v-if="!form.signPartner" :src="offIcon" alt="">
              <img v-else :src="onIcon" alt="">
            </div>
            <div class="content">本人已阅读、知晓并同意<span class="link-text" @click="viewAgreement('promotion')">《光子易推广人协议》</span>的全部内容，同意并接受全部条款后开始使用。</div>
          </div>
        </div>
        <div v-if="isAdd">
         <vanButton
            round
            type="primary"
            size="large"
            :disabled="disabled"
            :loading="submitLoading"
            @click="submit"
          >
            <!-- 提交 -->
            同意并添加银行卡
          </vanButton>
        </div>
        <BindSuccess ref="bindSuccess"></BindSuccess>
    </div>
</template>
<script>
import { apiPost, apiGet } from '@/services'
import offIcon from '@/assets/images/settle/checkOff.png'
import onIcon from '@/assets/images/settle/checkOn.png'
import maskImg from '@/assets/images/settle/mask.png'
import noMaskImg from '@/assets/images/settle/noMask.png'
import BindSuccess from './bindSuccess'
import { mapState } from 'vuex'
import {session} from '@/utils'

const defaultData = {
    bankAccountName: '',
    bankName: '',
    bankCard: '',
    idCard: '',
    bankPhone: '',
    accountName: '',
    signPrivacy: false, // 《敏感个人信息处理事宜授权书》
    signPartner: false // 《光子易推广人协议》
}

export default {
    name: 'settle-card',
    components: {
      BindSuccess
    },
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value) {
            const regex = /^1[3-9]\d{9}$/
            if (regex.test(value)) {
              callback()
            } else {
              callback(new Error('请输入正确的手机号码'))
            }
        } else {
            callback(new Error('请输入正确的手机号码'))
        }
      }
      // 身份证
      var validateIdCard = (rule, value, callback) => {
        if (value) {
            // 定义正则表达式来匹配 15 位和 18 位身份证号码
          const reg15 = /^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$/
          const reg18 = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/

          if (reg15.test(value)) {
              // 15 位身份证号码校验
              // 可以进一步添加对 15 位身份证号码的详细校验逻辑，如出生日期等
              return callback()
          } else if (reg18.test(value)) {
            // 18 位身份证号码校验
            const weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 加权因子
            const verifyCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // 校验码对应值
            let sum = 0
            for (let i = 0; i < 17; i++) {
                sum += parseInt(value[i]) * weight[i]
            }
            const mod = sum % 11
            const lastChar = value[17].toUpperCase()
            if (lastChar === verifyCode[mod]) {
              callback()
            } else {
              callback(new Error('请检查并输入完整的身份证号码'))
            }
          }
          callback(new Error('请检查并输入完整的身份证号码'))
        } else {
          callback(new Error('请检查并输入完整的身份证号码'))
        }
      }
      return {
        key: 1,
        maskImg,
        visibilityFlag: false,
        noMaskImg,
        offIcon,
        onIcon,
        submitLoading: false,
        isMask: true,
        // 是否是新增结算卡
        isAdd: true,
        defaultData: {...defaultData},
        form: { ...defaultData },
        detail: {},
        maskDetail: {},
        loading: true,
        rules: {
          // 开户名称
          bankAccountName: [
            { required: true, message: '请输入正确的开户行名称', trigger: 'blur' }
          ],
          // 开户银行
          bankName: [
            { required: true, message: '请输入正确的开户银行', trigger: 'blur' }
          ],
          bankCard: [
            { required: true, message: '请检查并输入正确的卡号', trigger: 'blur' },
            {
            pattern: /^\d{16,}$/,
            message: '请检查并输入正确的卡号',
            trigger: 'blur'
          }
          ],
          idCard: [
            { required: true, message: '请检查并输入完整的身份证号码', trigger: 'blur' },
            { validator: validateIdCard, trigger: ['blur'] }
          ],
          bankPhone: [
            { required: true, message: '请输入正确的手机号', trigger: 'blur' },
            { validator: validatePhone, trigger: ['blur'] }
          ],
          accountName: [
            { required: true, message: '请输入正确的开户人姓名', trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },
    beforeDestroy() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
    beforeRouteEnter(to, from, next) {
      let data = {}
      apiGet('partner/open/home')
        .then(res => {
          if (res.code === '0000') {
            if (res.data.isAgree === 1) { // 有
              data = res.data
            }
          }
      }).finally(() => {
        next(vm => {
          vm.$store.commit('set_userInfo', data)
          vm.setData()
        })
      })
    },
    computed: {
      disabled() {
        const form = this.form
         for (const i in form) {
           if (form[i] === '') {
            return true
           }
         }
         if (!this.form.signPrivacy) {
          return true
         }
         if (this.showSignPartner && !this.form.signPartner) {
          return true
         }
        return false
      },
      showSignPartner() {
        // 提现人名字不是注册人名字，重新签协议
        return this.form.accountName && (this.userInfo.userName !== this.form.accountName)
      },
      ...mapState({
        userInfo: state => state.userInfo
      })
    },

    methods: {
      handleVisibilityChange() {
        if (!document.hidden && this.visibilityFlag) {
          console.log('页面重新可见')
          this.visibilityFlag = false
          this.setData() // 页面回退时调用初始化函数
        }
      },
      setData() {
        const cacheForm = session('card') || {}
        if (cacheForm && Object.prototype.hasOwnProperty.call(cacheForm, 'status')) {
          console.log(cacheForm, 'cacheForm')
          this.$nextTick(() => {
            this.$set(this, 'form', cacheForm)
            this.key += 1
            console.log(this.form, 'this.form')
          })
          this.loading = false
          setTimeout(() => {
            sessionStorage.removeItem('card')
          }, 1000)
        } else {
          this.get()
        }
      },
      viewAgreement(type) {
        // 查看协议缓存表单
        session('card', this.form)
        if (type === 'privacy') {
          this.visibilityFlag = true
          location.href = 'https://www.photonpay.com/policy/agreement/20210623162857620'
        } else {
          this.$router.push({
            path: '/agreement',
            query: {
              code: type
            }
          })
        }
      },
      switchSign(key) {
        this.$set(this.form, key, !this.form[key])
        console.log(this.form[key])
      },
      switchMask() {
        this.isMask = !this.isMask
        if (this.isMask) {
          this.form = {...this.maskDetail}
        } else {
          this.form = {...this.detail}
        }
      },
      get() {
        this.$loading()
        this.loading = true
        apiGet('partner/open/information/')
        .then(res => {
          if (res.code === '0000') {
            // 0 未绑卡，1绑卡
            this.isAdd = !res.data.status
            if (res.data.status) {
              this.detail = {...res.data}
              this.maskData(res.data)
              this.isMask = true
              this.form = {...this.maskDetail}
            } else {
              this.form = {
                ...res.data,
                accountName: this.userInfo.userName,
                bankPhone: this.userInfo.phone
              }
              console.log(this.form)
            }
          } else {
            this.$notify.error(res.msg)
          }
        }).finally(() => {
          this.loading = false
          this.$clearLoading()
        })
      },
      // 简单掩码处理
      maskData(data) {
        const {bankAccountName, bankCard, accountName, idCard, bankPhone} = data
        const maskDetail = {...data}
        maskDetail.bankPhone = bankPhone.slice(0, 3) + ' **** ' + bankPhone.slice(-4)
        maskDetail.bankCard = this.maskBankAccount(bankCard)
        maskDetail.idCard = idCard.slice(0, 4) + '**********' + idCard.slice(-4)
        maskDetail.accountName = accountName.slice(0, 1) + (accountName.length === 2 ? '*' : '**')
        maskDetail.bankAccountName = bankAccountName.slice(0, 4) + '****' + bankAccountName.slice(-2)
        this.maskDetail = maskDetail
      },
      maskBankAccount(account) {
        const maskedPart = '*'.repeat(account.length - 8)
        let maskedAccount = account.slice(0, 4) + maskedPart.slice(0, 4)
        for (let i = 4; i < maskedPart.length; i += 4) {
            maskedAccount += ' ' + maskedPart.slice(i, i + 4)
        }
        maskedAccount += ' ' + account.slice(-4)
        return maskedAccount
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            const data = {...this.form}
            this.submitLoading = true
            if (!this.showSignPartner) {
              delete data.signPartner
            }
            apiPost('partner/open/information/bind', this.form)
            .then(res => {
              if (res.code === '0000') {
                this.$notify.success(res.msg)
                // 成功页
                this.$refs.bindSuccess.show = true
                this.isAdd = false
              } else {
                this.$notify.error(res.msg)
              }
            }).then(() => {
              this.submitLoading = false
            }).finally(() => {
              sessionStorage.removeItem('card')
            })
          }
        })
      }
    }
}
</script>
<style lang="less" scoped>
/deep/.van-button--disabled {
  background: #444757 !important;
  color: rgba(255,255,255,0.40) !important;
}
/deep/.van-button--primary {
  background: #ffdd3f;
  font-weight: 600;
  border: 0px;
  color: #121212;
}
/deep/.normal-form .el-input{
  display: block;
}
/deep/.normal-form .el-input input {
  background: #fff;
  color: #302B3E;
  font-size: 14px;
  height: 22px;
  font-weight: 600;
  line-height: 22px;
  &::placeholder {
   color: #666666;
   font-size: 10px;
  }
}
/deep/.normal-form .el-form-item {
  width: 100%;
  border-bottom: 1px solid #E5E5E5;
  display: flex;
  .el-form-item__content{
    width: calc(100% - 90px);
    display: block;
    line-height: normal;
  }
  .el-form-item__label{
    padding-right: 0;
    padding-bottom: 0;
    padding-top: 2px;
    font-weight: 600;
    width: 90px;
  }
  .el-form-item__error{
    left: -90px !important;
    bottom: -10px;
  }
}
/deep/.normal-form.disabled-form .el-input .el-input__inner {
  color: #fff;
}
/deep/.normal-form .el-input.is-disabled .el-input__inner{
  color: #302b3e !important;
  opacity: 1;
}
.link-text{
  color: #5C288D;
}
.signature{
  padding: 0 27px;
  .signature-item{
    display: flex;
    margin-bottom: 10px;
  }
  .img-box{
    margin-top: 2px;
    width: 22px;
    flex-shrink: 0;
    img{
      display: block;
      width: 14px;
      height: 14px;
    }
  }
  .content{
    font-size: 12px;
    color: #666666;
    line-height: 18px;
  }
}
.main{
    height: 100%;
    width: 100%;
    padding-bottom: 40px;
    background: #fff;
    .settle-top{
      padding: 0 27px;
      padding-top: 60px;
      display: flex;
      .mask{
        margin-left: 12px;
        height: 28px;
        display: flex;
        align-items: center;
        img{
          display: block;
          width: 20px;
          height: auto;
        }
      }
      .title{
        height:28px;
        font-size:22px;
        font-weight:800;
        color: #302B3E;
        line-height: 28px;
        margin-bottom: 30px;
      }
    }
    .ppw-form-container{
      padding: 0 27px;
      .el-form{
        margin: 0;
      }
    }
    .form{
        .form-item{
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 343px;
            padding-top: 22px;
            padding-bottom: 10px;
            border-bottom: 1px solid rgba(218,222,234,1);
            .lable{
                width: 120px;
                height:20px;
                font-size:14px;
                font-weight:500;
                color:rgba(18,57,160,1);
                line-height:20px;
                margin-bottom: 8px;
            }
            input{
                width: 100%;
                border: none;
                height:21px;
                font-size:15px;
                font-weight:500;
                color:rgba(40,45,59,1);
                line-height:21px;
                ::placeholder{
                    color:rgba(192,197,217,1);
                }
            }
            &.rows{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .lable{
                    margin: 0;
                }
                input{
                    text-align: right;
                    width: 100%;
                }
            }
        }
    }
    .van-button{
        width:calc(100vw - 110px);
        height:40px;
        background:#FFB600;
        border-radius:22px;
        font-weight:600 !important;
        color:#302B3E;
        line-height:40px;
        text-align: center;
        font-size: 16px;
        margin: 0 auto;
        display: block;
        margin-top: 60px;
        margin-bottom: 20px;
    }
}
</style>
